<div class="pp" [class.pp--compact]="variant === 'compact'">
    <div role="radiogroup" aria-label="Billing" class="pp-plans">
        <button type="button" role="radio" class="pp-card" [class.pp-card--on]="plan === 'monthly'"
            [attr.aria-checked]="plan === 'monthly'" (click)="selectPlan('monthly')">
            <span class="pp-card-name">Monthly</span>
            <span class="pp-card-price">
                <span class="pp-card-amount">{{ view.monthlyPrice }}</span>
                <span class="pp-card-unit" *ngIf="variant !== 'compact'">per person / month</span>
                <span class="pp-card-unit" *ngIf="variant === 'compact'">/ person / mo</span>
            </span>
            <span class="pp-card-note" *ngIf="variant !== 'compact'">Billed monthly</span>
        </button>
        <button type="button" role="radio" class="pp-card" [class.pp-card--on]="plan === 'yearly'"
            [attr.aria-checked]="plan === 'yearly'" (click)="selectPlan('yearly')">
            <span class="pp-card-head">
                <span class="pp-card-name">Yearly</span>
                <span class="pp-save" *ngIf="view.saveTag">{{ view.saveTag }}</span>
            </span>
            <span class="pp-card-price">
                <span class="pp-card-amount">{{ view.yearlyPrice }}</span>
                <span class="pp-card-unit" *ngIf="variant !== 'compact'">per person / month</span>
                <span class="pp-card-unit" *ngIf="variant === 'compact'">/ person / mo</span>
            </span>
            <span class="pp-card-note" *ngIf="variant !== 'compact'">{{ view.yearlyNote }}</span>
        </button>
    </div>

    <div class="pp-people" *ngIf="fixedPeople === null">
        <span class="pp-people-text">
            <span class="pp-people-label">People</span>
            <span class="pp-people-hint" *ngIf="variant !== 'compact'">{{ view.hint }}</span>
        </span>
        <div class="pp-stepper">
            <button type="button" class="pp-step" aria-label="Fewer people" [disabled]="!view.canDecrease" (click)="decrease()">
                <lucide-icon name="minus" [size]="view.stepIconSize" class="no-fill"></lucide-icon>
            </button>
            <span class="pp-count" aria-live="polite">{{ people }}</span>
            <button type="button" class="pp-step" aria-label="More people" [disabled]="!view.canIncrease" (click)="increase()">
                <lucide-icon name="plus" [size]="view.stepIconSize" class="no-fill"></lucide-icon>
            </button>
        </div>
    </div>

    <div class="pp-included" *ngIf="variant === 'full'">
        <span class="pp-included-title">Everything is included</span>
        <div class="pp-included-list">
            <span class="pp-included-item" *ngFor="let feature of features; trackBy: trackByFeature">
                <span class="pp-check"><lucide-icon name="check" [size]="14" class="no-fill"></lucide-icon></span>{{ feature }}
            </span>
        </div>
    </div>

    <div class="pp-checkout">
        <div class="pp-total">
            <span class="pp-total-label">{{ view.totalLabel }}</span>
            <span class="pp-total-amount" aria-live="polite">{{ view.total }}</span>
        </div>
        <ng-content></ng-content>
    </div>
</div>
